/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Event helper class
 **/
define([], function() {

	/**
	 * Recursively
	 */
	const retrieveContentAndIsDescendants = (content, expandedResult) => {
		if (content) {
			if (Array.isArray(content)) {
				content.forEach(item => {
					retrieveContentAndIsDescendants(item, expandedResult);
				});
			} else if (content.getType() === 'group') {
				expandedResult.groupCount++;
				expandedResult.groups.push(content);
				const children = content.getChildren();
				children.forEach(child => {
					retrieveContentAndIsDescendants(child, expandedResult);
				});
			} else {
				expandedResult.contentList.push(content);
			}
		}
	};

	class ContentUtil {
		/**
		 * Recursively walk the content and it's parent to find the page content.
		 * @param {ContentAPI} content
		 * @param {String} [type='page'] the content type.
		 * @returns {ContentAPI} page content. If the type can not be found, returns null
		 */
		static getPageContent(content, type = 'page') {
			let pageContent = null;
			while(content) {
				if (type && content.getType() === type) {
					pageContent = content;
				}
				content = content.getContainer();
			}
			return pageContent;
		}

		/**
		 * Recursively walk the content or array of contents and their descendants and return all contents.
		 * @param {ContentAPI|ContentAPI[]} content
		 * @returns {object} and object containing array of contents and the nunber of group count defined in the content
		 */
		static getContentAndItsDescendants (content) {
			const result = {
				contents: [],
				contentList: [],
				groups: [],
				groupCount: 0
			};
			retrieveContentAndIsDescendants(content, result);
			result.contents.push(...result.groups, ...result.contentList);
			return { contents: result.contents, groupCount: result.groupCount  };
		}
	}
	return ContentUtil;
});
